import { useWorkflowByID } from "@src/data-hooks/workflows/workflows.service";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { CreatedByData } from "../../../../to-be-removed/LocalData/General/CreatedByData";
import { UserData } from "../../../../to-be-removed/LocalData/User/UserData";
import { Label } from "../../Label/Label";
import { Popup } from "../../Popup/Popup";
import { UserPopUp } from "../../UserPopup/UserPopUp";
import style from "./UserNameLabel.module.css";

interface UserNameLabelProps {
  type: "paragraph" | "paragraph-2" | "header-1" | "header-2" | "header-3" | "header-4" | "subtitle" | "subtitle-2";
  user?: UserData;
  createdBy?: CreatedByData;
  className?: string;
  disableUserPopUp?: boolean;
}

export const UserNameLabel = (props: UserNameLabelProps) => {
  const [, setLastUpdate] = useState(new Date());

  const { workflow } = useWorkflowByID(props.createdBy?.workflowID);

  let text = "";

  if (props.user) text = props.user?.name ? props.user.name : props.user.loaded ? "" : t("main.loading");
  else if (props.createdBy?.apiClient)
    text = props.createdBy?.apiClient?.name ? props.createdBy.apiClient.name : props.createdBy.apiClient.loaded ? "" : t("main.loading");
  else if (workflow) text = workflow.name;
  else text = t("main.noUser");

  useEffect(() => {
    let mounted = true;
    if (props.user && !props.user.loaded) {
      props.user.load().then(() => {
        if (mounted) setLastUpdate(new Date());
      });
    } else if (props.createdBy?.apiClient && !props.createdBy.apiClient.loaded) {
      props.createdBy.apiClient.load().then(() => {
        if (mounted) setLastUpdate(new Date());
      });
    }

    return () => {
      mounted = false;
    };
  }, [props.user, props.createdBy]);

  function handleOnClickEvent() {
    if (props.user && !props.disableUserPopUp) {
      Popup.present((id) => <UserPopUp id={id} user={props.user!} />);
    }
  }

  let className = props.type;
  if (props.className) {
    className += " " + props.className;
  }

  return (
    <div className={style.userNameLabel} onClick={handleOnClickEvent}>
      <Label type={props.type} underlineWidth={0} className={className} text={text} />
    </div>
  );
};

interface UserNameProps {
  user?: UserData;
  className?: string;
  prefix?: string;
}

export const UserName = (props: UserNameProps) => {
  let [text, setState] = useState(t("main.loadingUser"));

  function loadUser() {
    let mounted = true;
    if (props.user) {
      if (!props.user.loaded) {
        props.user.load().then((err) => {
          if (mounted) setState(err || !props.user ? "Error" : props.user.name);
        });
      } else {
        if (mounted) setState(props.user.name);
      }
    } else {
      if (mounted) setState(t("main.noUser"));
    }

    return function cleanup() {
      mounted = false;
    };
  }

  useEffect(loadUser, [props.user?.name, props.user?.loaded === true]);

  return (
    <span className={props.className}>
      {props.prefix ? props.prefix : ""}
      {text}
    </span>
  );
};
